var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rocket-solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.002,
    height: 32.004,
    viewBox: "0 0 32.002 32.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rocket-solid-2",
    "data-name": "rocket-solid",
    d: "M9.728,24.08,7.8,22.149a1.955,1.955,0,0,1-.481-2.013c.188-.556.438-1.281.738-2.113H1.441A1.5,1.5,0,0,1,.147,15.761L3.428,10.23A4.5,4.5,0,0,1,7.3,8.023h5.144c.15-.25.3-.481.45-.706C18.01-.233,25.635-.483,30.185.354A1.777,1.777,0,0,1,31.61,1.779c.838,4.556.581,12.176-6.963,17.295-.219.15-.456.3-.706.45v5.144a4.491,4.491,0,0,1-2.206,3.869L16.2,31.818a1.5,1.5,0,0,1-2.263-1.294v-6.7c-.881.306-1.65.556-2.231.744a1.97,1.97,0,0,1-1.988-.488ZM23.941,10.523a2.5,2.5,0,1,0-2.5-2.5,2.5,2.5,0,0,0,2.5,2.5Z",
    transform: "translate(0.063 -0.024)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketSolid);
export default __webpack_public_path__ + "static/media/rocket-solid.fb7cff8f.svg";
export { ForwardRef as ReactComponent };